export class GroupDeviceInfo {
    public serialNumber: string;
    constructor(obj: any) {
        this.serialNumber = obj?.serialNumber;
    }
}
